export const metadata = {
  id: 'sync_akeneo',
  title: 'Akeneo Product Sync',
  description: 'Import Akeneo PIM categories, product attributes, and products into the Open Mercato catalog.',
  requires: ['integrations', 'data_sync', 'catalog', 'sales'],
}
